/**
 * TUS ITEMS Y PRECIOS COMO EL CATALOGO DEL ITEM ESTANDAR (CATALOGO-UNICO-ITEMS-T1, maqueta aprobada por Josse, Ares #43601).
 *
 * AUDIENCIA: Josse y el asesor de Maderinco, escritorio o celular, solo el negocio demo. Contrato de pantalla: la maqueta
 * https://claude.ai/artifact/FTvBEHapj9gvLDEV5c6pc7 (version 1793763895-2c02), vista "Tus items y precios".
 *
 * Buscar, Ir a, filtros Todos / Precio por confirmar / Por clasificar, secciones a la vista (MAD-MIS-ITEMS-VISTA-T1) y una fila por
 * estandar: tipo, nombre armado, precio por unidad y Editar en su sitio. El editor (montarEditorEstandar, el mismo de la
 * fila del asistente desde MAD-LAPIZ-ITEM-T1) es el del 699 (control por
 * caracteristica, el nombre al instante, lo que la base frenaria apaga Guardar) con el precio y Duplicar como variante.
 * Lee GET plantilla/item-estandar (nexo-api 785); guarda con PUT/POST de nexo-api 788. Reglas sin DOM en
 * application/presupuestos/itemEstandar.js; lo prueba scripts/check-item-estandar.mjs.
 *
 * @module presentation/components/presupuestos/CatalogoEstandar
 */
import { PresupuestosApiClient } from '../../../infrastructure/api/PresupuestosApiClient.js';
import { leerItemEstandar, nombreArmado, armadoEnLaLinea, conNombre, nombreQueQueda, fallasDe, fraseDeFalla, conCaracteristica, varianteDe, nuevoEstandar, estandarVacio, cuerpoDeEstandar, cuerpoDeNuevo, fraseDelGuardado, usoDe, preguntaDeEliminar, fraseDelEliminado, caracteristicasDelEditor, alternarValor, conPrecio } from '../../../application/presupuestos/itemEstandar.js';
import { etiquetasCortas } from '../../../application/presupuestos/asistentePasos.js';
import { listaDeItems } from '../../../application/presupuestos/listaDeItems.js';
import { capituloSugerido, destinosDeLinea, itemPorClasificar, planDeClasificar, idDelEstandar, igualEnLaLinea, fraseDelPlan, fraseDelClasificado, TOPE_NOMBRE } from '../../../application/presupuestos/clasificarItems.js';
import { formatearCOP, parsearNumeroColombiano } from '../../shared/numeroColombiano.js';
import { esc } from '../../shared/texto.js';
import { DONDE_SALE, descripcionesViejas, descripcionParaElCliente, origenDeLaDescripcion, conDescripcion, nombreRepetido, filasDeDatos } from '../../../application/presupuestos/nombreYDescripcion.js';

const MOTIVOS = {
  NOT_IMPLEMENTED: 'La API todavía no publica el ítem estándar. Se enciende sola cuando A lo sirva (nexo-api 785).',
  FORBIDDEN: 'No tienes permiso para ver el ítem estándar de este negocio.',
  NEGOCIO_AJENO: 'El ítem estándar es solo del negocio demo de Maderinco: elige ese negocio arriba.'
};
export const motivoDe = (res) => MOTIVOS[res?.error?.code] || 'No pudimos hablar con la API ahora. Intenta de nuevo en un momento.';
const UNIDAD = { m2: 'm²', 'm²': 'm²', ml: 'ml', m: 'm', und: 'und', un: 'und', gnral: 'global', gl: 'global', m3: 'm³' };
const unidadBonita = (u) => UNIDAD[String(u || '').toLowerCase()] || (u ? String(u) : 'und');
// Pesos enteros con su signo, como la maqueta ('$ 274.000'): formatearCOP no pone el signo y muestra centavos.
const plata = (n) => '$ ' + formatearCOP(Math.round(Number(n) || 0));
const hoy = () => new Date().toISOString().slice(0, 10);

// EDITOR-ITEM-DISENO-T1 (maqueta 1793770085-ef18): cada caracteristica con sus opciones como chips de 44 px. Lista = una
// sola y "No lleva"; casillas = varias; numero = el campo y hasta 4 valores de la plantilla a un toque.
function grupoHtml(c, valores) {
  const v = valores || [];
  const chip = (x, varios) => `<button type="button" class="ce-op" data-ce-valor="${esc(c.nombre)}" data-v="${esc(x)}"${varios ? ' data-varios' : ''} aria-pressed="${v.includes(x)}">${esc(x)}</button>`;
  if (c.control === 'numero') {
    return `<div class="ce-car"><span>${esc(c.nombre)}${c.unidad ? ` (${esc(c.unidad)})` : ''}</span><div class="ce-ops">
      <input type="text" inputmode="decimal" class="ce-num" data-ce-car="${esc(c.nombre)}" value="${esc(v[0] || '')}" aria-label="${esc(c.nombre)}">
      ${c.opciones.slice(0, 4).map((x) => chip(x, false)).join('')}</div></div>`;
  }
  const varios = c.control === 'casillas';
  return `<div class="ce-car"><span>${esc(c.nombre)}${varios ? ' (puedes marcar varias)' : ''}</span><div class="ce-ops" role="group" aria-label="${esc(c.nombre)}">
    ${c.opciones.map((x) => chip(x, varios)).join('')}
    ${varios ? '' : `<button type="button" class="ce-op ce-op-no" data-ce-valor="${esc(c.nombre)}" data-v="" aria-pressed="${!v.length}">No lleva</button>`}</div></div>`;
}

const fechaBonita = (f) => (f === hoy() ? 'hoy' : f.split('-').reverse().join('/'));
const vigenciaTexto = (b, referencia) => [
  b.precio === null || b.precio === undefined ? 'sin precio: queda por confirmar' : `vigente desde ${fechaBonita(b.vigenteDesde || hoy())}`,
  referencia ? `referencia de la plantilla ${plata(referencia)}` : ''
].filter(Boolean).join(' · ');
const precioEnCampo = (p) => (p === null || p === undefined ? '' : Number.isInteger(Number(p)) ? formatearCOP(Number(p)) : String(p).replace('.', ','));

/**
 * El editor como la maqueta: el nombre que queda arriba y grande, a que alcanza el cambio, el tipo y lo que distingue
 * como chips, lo demas en "Mas caracteristicas", el precio con su vigencia y Guardar. extra = { distingue, referencia,
 * alAbrir (las caracteristicas al abrir, que fijan los grupos) }.
 */
/**
 * MAD-LAPIZ-COMPLETO-T1 (maqueta CN3bqybMgFosfhZKxrMTQY): el nombre se puede escribir. La nota dice si es el armado o uno
 * escrito a mano y, si es a mano, cual seria el armado y "Volver al nombre armado".
 */
function notaDelNombre(armado, aMano) {
  return aMano
    ? `<span>Escrito a mano. El armado sería: <b>${esc(armado)}</b></span><button type="button" class="ce-boton" data-ce-volver>Volver al nombre armado</button>`
    : '<span>Armado con las características. Puedes escribir otro.</span>';
}

/**
 * MAD-ELIMINAR-ITEM-T1 (maqueta 4pEwA37HR3BTGuvfy2EUZR): la pregunta en la misma ventana. Primero se cuenta en cuantos
 * presupuestos esta (GET {id}/uso, unos segundos); con la cifra, Si (archivar o eliminar) y No.
 */
function borrarHtml(borrar) {
  if (borrar.contando) return '<div class="ce-borrar" role="status" data-ce-borrar><p>Contando en cuántos presupuestos está…</p></div>';
  return `<div class="ce-borrar" role="alertdialog" aria-label="Confirmar eliminar" data-ce-borrar>
    <p>${esc(borrar.pregunta.texto)}</p>
    ${borrar.error ? `<p class="ce-borrar-error" role="alert">${esc(borrar.error)}</p>` : ''}
    <div class="ce-fila"><button type="button" class="ce-boton ce-borrar-si" data-ce-eliminar-si${borrar.enviando ? ' disabled' : ''}>${borrar.enviando ? 'Un momento…' : esc(borrar.pregunta.boton)}</button>
      <button type="button" class="ce-boton" data-ce-eliminar-no${borrar.enviando ? ' disabled' : ''}>No</button></div></div>`;
}

/**
 * MAD-NOMBRE-PARAMETROS-DESCRIPCION-T1 (maqueta VDDDk8sxb5T1omNLunuNNs, SI #44226): la parte 3, la descripcion para el
 * cliente, con donde sale. Hoy es el texto del item de la plantilla (el de tu presupuesto viejo) y se ve tal cual;
 * escribirla aqui llega cuando la API publique la descripcion escrita a mano (#44241). Si hay varias viejas, se dice.
 */
export function descripcionHtml(estandar, b = null) {
  if (!estandar) return '';
  // Lo que se esta editando manda sobre lo guardado (la escrita del borrador).
  const est = b ? { ...estandar, descripcionManual: b.descripcionManual || null } : estandar;
  const viejas = descripcionesViejas(est);
  const origen = origenDeLaDescripcion(est);
  const actual = descripcionParaElCliente(est);
  // nexo-api 802: con la API que la acepta y un item guardado, se escribe aqui (PUT descripcionManual).
  const editable = !!(b && b.id && estandar.aceptaDescripcion);
  const usar = (t, i) => editable ? `<button type="button" class="ce-boton" data-ce-desc-usar="${i}">Usar este</button>` : '';
  return `<div class="ce-desc" data-ce-desc><h3 class="ce-parte">Descripción para el cliente</h3>
    ${editable
      ? `<textarea id="ce-desc" class="ce-desc-campo" data-ce-desc-manual rows="4" aria-label="Descripción para el cliente">${esc(actual)}</textarea>
         ${origen === 'escrita' ? '<button type="button" class="ce-boton" data-ce-desc-volver>Volver a la de tus presupuestos</button>' : ''}`
      : actual ? `<p class="ce-desc-texto" data-ce-desc-texto>${esc(actual)}</p>` : '<p class="ce-desc-texto">Sin descripción: en el presupuesto sale solo el nombre.</p>'}
    ${viejas.length > (editable ? 0 : 1) && (editable || origen !== 'escrita') ? `<details class="ce-mas"><summary>Ver ${viejas.length === 1 ? 'el texto' : `los ${viejas.length} textos`} de tus presupuestos</summary><ol class="ce-desc-viejas">${viejas.map((t, i) => `<li><span>${esc(t)}</span>${usar(t, i)}</li>`).join('')}</ol></details>` : ''}
    <p class="ce-sale" data-ce-sale="descripcion">${saleDeLaDescripcion(est)}</p></div>`;
}

/** La linea 'Sale en' de la descripcion con de donde viene (se repinta sola al escribir, sin tocar el campo). */
function saleDeLaDescripcion(est) {
  const origen = origenDeLaDescripcion(est);
  const n = descripcionesViejas(est).length;
  const de = origen === 'escrita' ? 'Escrita a mano.' : origen === 'vieja'
    ? (n > 1 ? `Sale el texto de la partida que elijas en el paso a paso: tus presupuestos viejos tienen ${n} para este ítem.` : 'Viene de tu presupuesto viejo.')
    : origen === 'generada' ? 'Armada con el nombre y lo que incluye.' : '';
  return `${esc(de)} Sale en: <b>${esc(DONDE_SALE.descripcion)}</b>.`;
}

const avisoRepetido = (linea) => `Ya hay otro ítem en ${esc(linea.linea)} con este nombre: cámbialo para distinguirlos.`;

function editorHtml(linea, b, unidad, extra = {}) {
  const pl = linea.plantilla;
  const fallas = fallasDe(pl, b.caracteristicas);
  const { arriba, mas } = caracteristicasDelEditor(pl, extra.alAbrir || b.caracteristicas, extra.distingue);
  // MAD-EDICION-COHERENTE-T1 (maqueta 9xVkFa2wbUhPrH7NosTaHC, GO #44415): la linea es el grupo (arriba, no se edita);
  // nombre, precio y descripcion primero; los datos plegados como lista con 'Cambiar' (no botones que parecen otras opciones).
  const nombre = nombreQueQueda(linea, b);
  const repetido = nombreRepetido(linea.estandar, b.id, nombre);
  const filas = filasDeDatos(pl.tipos, [...arriba, ...mas], b);
  const porNombre = new Map([...arriba, ...mas].map((c) => [c.nombre, c]));
  const abierto = extra.datosAbierto ?? (!b.id || fallas.length > 0);
  const filaHtml = (f) => {
    const cambiando = extra.cambiando === f.clave;
    const grupo = !cambiando ? '' : f.esTipo
      ? `<div class="ce-car"><div class="ce-ops" role="group" aria-label="Tipo">${pl.tipos.map((t) => `<button type="button" class="ce-op" data-ce-tipo="${esc(t)}" aria-pressed="${b.tipo === t}">${esc(t)}</button>`).join('')}</div></div>`
      : grupoHtml(porNombre.get(f.clave), b.caracteristicas[f.clave]);
    return `<div class="ce-dato${cambiando ? ' abierto' : ''}"><dt>${esc(f.clave)}</dt><dd>${esc(f.valor)}</dd>
      <button type="button" class="ce-boton ce-cambiar" data-ce-cambiar="${esc(f.clave)}" aria-expanded="${cambiando}">${cambiando ? 'Listo' : 'Cambiar'}</button>${grupo}</div>`;
  };
  return `<section class="ce-editor" data-ce-editor aria-label="Editar el ítem">
    <p class="ce-arriba"><span>${esc(linea.linea)}</span> › <b>${b.id ? 'editando este ítem' : b.nuevo ? 'ítem nuevo' : 'variante nueva'}</b> · ${b.id ? 'el cambio queda en Tus ítems y en los próximos presupuestos' : 'queda en Tus ítems y sale en el armador'}</p>
    <div class="ce-cabeza ce-nombre-campo"><label for="ce-nombre">Nombre</label>
      <input id="ce-nombre" type="text" class="ce-nombre${b.nombreManual ? ' a-mano' : ''}" data-ce-nombre value="${esc(nombre)}" autocomplete="off">
      <p class="ce-sale" data-ce-sale="nombre">Sale en: <b>${esc(DONDE_SALE.nombre)}</b>.</p>
      <div class="ce-nombre-nota" data-ce-nombre-nota aria-live="polite">${notaDelNombre(armadoEnLaLinea(linea, b), !!b.nombreManual)}</div>
      <p class="ce-repetido" data-ce-repetido role="status"${repetido ? '' : ' hidden'}>${repetido ? avisoRepetido(linea) : ''}</p></div>
    ${b.id || b.nuevo ? `<div class="ce-precio"><label for="ce-precio">Precio por ${unidadBonita(unidad)}<input id="ce-precio" type="text" inputmode="decimal" class="ce-num" data-ce-precio value="${esc(precioEnCampo(b.precio))}" placeholder="por confirmar"></label>
      <span class="ce-vigencia" data-ce-vigencia>${esc(vigenciaTexto(b, extra.referencia))}</span></div>` : ''}
    ${descripcionHtml(extra.estandar, b)}
    <details class="ce-datos" data-ce-datos${abierto ? ' open' : ''}><summary>Datos para ordenar y buscar <span>(${filas.filter((f) => f.lleno).length} de ${filas.length})</span></summary>
      <p class="ce-sale" data-ce-sale="parametros">Sirven para ${esc(DONDE_SALE.parametros)}.</p>
      <dl class="ce-lista">${filas.map(filaHtml).join('')}</dl></details>
    ${fallas.length ? `<ul class="ce-fallas" data-ce-fallas>${fallas.map((f) => `<li>${esc(fraseDeFalla(f))}</li>`).join('')}</ul>` : ''}
    <div class="ce-fila">
      <button type="button" class="ce-guardar" data-ce-guardar${fallas.length ? ' disabled' : ''}>${b.id ? 'Guardar' : b.nuevo ? 'Crear ítem' : 'Crear variante'}</button>
      <button type="button" class="ce-boton" data-ce-cancelar>Cancelar</button>
      ${b.id ? '<button type="button" class="ce-boton" data-ce-duplicar>Duplicar como variante</button>' : ''}
      ${b.id && extra.puedeEliminar ? '<button type="button" class="ce-boton ce-eliminar" data-ce-eliminar aria-haspopup="true">Eliminar</button>' : ''}
      <span class="ce-resultado" data-ce-resultado role="status"></span>
    </div>${extra.borrar ? borrarHtml(extra.borrar) : ''}</section>`;
}

/**
 * MAD-MIS-ITEMS-VISTA-T1 (maqueta 4pEwA37HR3BTGuvfy2EUZR, propuesta A, SI de Josse #43980): la lista. Arriba, pegados al
 * bajar, buscar, "Ir a" una seccion y los filtros con sus cuentas; las secciones a la vista (sin acordeon), cada linea con
 * cuantos tiene y una fila por item: nombre corto (lo que lo distingue en su linea), precio por unidad con "por
 * confirmar" y el lapiz que abre el editor debajo. Lo pintado, puro sobre la lectura y el estado (para el guardia).
 * estado: { filtro, buscar, borrador }
 */
export function catalogoHtml(lectura, estado) {
  const li = listaDeItems(lectura, estado);
  const c = li.cuentas;
  const filtros = [['todos', `Todos (${c.todos})`], ['por_confirmar', `Precio por confirmar (${c.porConfirmar})`], ['por_clasificar', `Por clasificar (${c.porClasificar})`]];
  const clasificar = estado.filtro === 'por_clasificar';
  const filtrado = !clasificar && (estado.buscar || estado.filtro === 'por_confirmar');
  const cuenta = clasificar ? `${c.porClasificar} por clasificar` : filtrado ? `${li.visibles} de ${li.total} ítems` : '';
  const cabeza = `<p class="ce-ayuda">Lo que usa el asistente para armar presupuestos. Cada ítem con su nombre corto, su precio por unidad y si falta confirmarlo.</p>
    <div class="ce-barra" data-ce-barra>
      <div class="ce-buscar-fila"><input type="search" class="ce-buscar" data-ce-buscar placeholder="Buscar: teja, cercha, ventana…" aria-label="Buscar en tus ítems" value="${esc(estado.buscar || '')}" autocomplete="off">
        ${clasificar ? '' : `<select class="ce-saltar" data-ce-saltar aria-label="Ir a una sección"><option value="">Ir a…</option>${li.secciones.map((x) => `<option value="${x.capitulo}">${esc(x.nombre)}</option>`).join('')}</select>`}</div>
      <div class="ce-filtros" role="group" aria-label="Filtro">${filtros.map(([k, t]) => `<button type="button" class="ce-filtro" data-ce-filtro="${k}" aria-pressed="${estado.filtro === k}">${t}</button>`).join('')}
        ${clasificar ? '' : `<button type="button" class="ce-nuevo" data-ce-nuevo aria-expanded="${!!estado.nuevoEn}">+ Nuevo ítem</button>`}</div>
      <span class="ce-cuenta" data-ce-cuenta aria-live="polite">${cuenta}</span>
    </div>`;
  const aviso = estado.aviso ? `<p class="ce-aviso" role="status" data-ce-aviso>${esc(estado.aviso)}</p>` : '';
  if (clasificar) return cabeza + aviso + clasificarHtml(lectura, estado);
  const nuevo = estado.nuevoEn ? nuevoEnHtml(lectura, estado.nuevoEn) : '';
  const items = (n) => `${n} ${n === 1 ? 'ítem' : 'ítems'}`;
  const cuerpo = li.secciones.map((x) => `<section class="ce-seccion" id="ce-s-${x.capitulo}" data-ce-seccion="${x.capitulo}"><h2>${esc(x.nombre)}<span>${items(x.cuantos)}</span></h2>
    ${x.lineas.map((l) => `<div class="ce-linea" data-ce-linea="${l.n}"><div class="ce-linea-cabeza"><b>${esc(l.linea)}</b><span>${items(l.filas.length)}</span></div><div class="ce-filas">
      ${l.filas.map((f) => {
        const abierto = !!(estado.borrador && estado.borrador.n === l.n && estado.borrador.desde === f.id);
        return `<div class="ce-item" data-ce-item="${esc(f.id)}">
          <div class="ce-item-nombre"><b>${esc(f.corto)}</b>${f.extra ? `<small>${esc(f.extra)}</small>` : ''}${f.tipo ? `<small>${esc(f.tipo)}</small>` : ''}</div>
          <div class="ce-item-precio"><b class="ce-num">${f.precio === null ? '—' : plata(f.precio)}</b><small>por ${unidadBonita(f.unidad)}</small>${f.porConfirmar ? '<span class="ce-estado">por confirmar</span>' : ''}</div>
          <button type="button" class="ce-lapiz" data-ce-editar="${esc(f.id)}" aria-expanded="${abierto}" aria-label="Editar ${esc(f.corto)}" title="Editar">&#9998;</button>
        </div>${abierto ? '<div class="ce-editor-host" data-ce-editor-host></div>' : ''}`;
      }).join('')}</div></div>`).join('')}</section>`).join('');
  return cabeza + aviso + nuevo + (cuerpo || '<p class="ce-vacio" data-ce-vacio>Nada coincide con esa búsqueda. Prueba con otra palabra o quita el filtro.</p>');
}

/**
 * MAD-CLASIFICAR-ITEMS-T1 (maqueta 4pEwA37HR3BTGuvfy2EUZR, filtro "Por clasificar"): los items sin linea por seccion de la
 * plantilla, cada uno con su lapiz. Abierto: seccion y linea del cliente (la sugerida es la que se llama igual), si se suma
 * a uno que ya hay en la linea o es uno nuevo (con su nombre a mano, que arranca con la descripcion) y Clasificar.
 * estado.clasif = { itemId, ck, lk, destino, nombre, error }.
 */
/**
 * Uno nuevo (DECISION #44081, nexo-api 798): solo el nombre a mano, que arranca con la descripcion del item. El nombre es
 * lo que lo distingue (la clave de la 031 lo incluye): si ya hay uno con ese nombre en la linea, se dice cual y Clasificar
 * se apaga. Tipo, caracteristicas y precio se ponen despues en el editor.
 */
function nombreDelNuevo(cl, it) { return cl.nombre ?? (it.descripcion || ''); }
function igualDelNuevo(lin, cl, it) {
  return igualEnLaLinea(lin, { tipo: null, caracteristicas: {}, nombreManual: String(nombreDelNuevo(cl, it)).trim().slice(0, TOPE_NOMBRE) });
}
function avisoDelIgual(lin, igual) {
  if (!igual) return '';
  const corto = (destinosDeLinea(lin).find((d) => d.id === igual.id) || {}).corto;
  return fraseDelPlan({ fallas: ['IGUAL_A_UNO_QUE_YA_HAY'] }, corto);
}
function nuevoHtml(lin, it, cl) {
  const igual = igualDelNuevo(lin, cl, it);
  return `<div class="ce-cabeza ce-nombre-campo"><label for="ce-cl-nombre">Nombre del ítem nuevo</label>
      <input id="ce-cl-nombre" type="text" class="ce-nombre" data-ce-cl-nombre maxlength="${TOPE_NOMBRE}" value="${esc(nombreDelNuevo(cl, it))}" autocomplete="off">
      <div class="ce-nombre-nota"><span>Escrito a mano: así sale en el armador y en Tus ítems. Tipo, características y precio se ponen después en el editor.</span></div>
      <p class="ce-resultado ce-cl-igual" role="status" data-ce-cl-igual${igual ? '' : ' hidden'}>${esc(avisoDelIgual(lin, igual))}</p></div>`;
}

export function clasificarHtml(lectura, estado) {
  const q = String(estado.buscar || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const pasa = (i) => !q || String(i.descripcion || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().includes(q);
  const grupos = ((lectura && lectura.porClasificar) || []).map((s) => ({ ...s, items: (s.items || []).filter(pasa) })).filter((s) => s.items.length);
  const caps = (lectura && lectura.capitulos) || [];
  const cl = estado.clasif;
  const panel = (s, it) => {
    const cap = caps[cl.ck] || caps[0];
    const lin = (cap && cap.lineas[cl.lk]) || (cap && cap.lineas[0]);
    if (!cap || !lin) return '';
    const destinos = destinosDeLinea(lin);
    const op = (valor, cuerpo) => `<button type="button" class="ce-destino" data-ce-cl-destino="${esc(valor)}" aria-pressed="${cl.destino === valor}">${cuerpo}</button>`;
    return `<section class="ce-editor ce-clasif" data-ce-clasif aria-label="Clasificar el ítem">
      <div class="ce-cabeza"><small>De la plantilla · ${esc(s.seccion)}</small><b class="ce-clasif-nombre">${esc(it.descripcion || it.ref)}</b>
        <small>${it.precioRef !== null ? `${plata(it.precioRef)} por ${unidadBonita(it.unidad)} · precio de referencia` : `por ${unidadBonita(it.unidad)}`}</small></div>
      <div class="ce-clasif-donde">
        <label>Sección<select class="ce-saltar" data-ce-cl-sec>${caps.map((c, k) => `<option value="${k}"${k === cl.ck ? ' selected' : ''}>${esc(c.nombre)}</option>`).join('')}</select></label>
        <label>Línea<select class="ce-saltar" data-ce-cl-lin>${cap.lineas.map((l, k) => `<option value="${k}"${k === cl.lk ? ' selected' : ''}>${esc(l.linea)}</option>`).join('')}</select></label>
      </div>
      <div class="ce-car"><span>¿Es uno de los que ya hay en ${esc(lin.linea)} o uno nuevo?</span>
        <div class="ce-destinos" role="group" aria-label="Dónde se suma">${destinos.map((d) => op(d.id, `<b>${esc(d.corto)}</b><span>${d.precio === null ? '—' : plata(d.precio)} / ${unidadBonita(d.unidad)}${d.porConfirmar ? ' · por confirmar' : ''}</span>`)).join('')}
          ${op('nuevo', '<b>Uno nuevo en esta línea</b><span>con su nombre; las características se ponen en el editor</span>')}</div></div>
      ${cl.destino === 'nuevo' ? nuevoHtml(lin, it, cl) : ''}
      <p class="ce-alcance">Al clasificar, el ítem sale de Por clasificar y aparece en el armador, en <b>${esc(cap.nombre)} › ${esc(lin.linea)}</b>.</p>
      ${cl.error ? `<p class="ce-resultado" role="alert" data-ce-cl-error>${esc(cl.error)}</p>` : ''}
      <div class="ce-fila"><button type="button" class="ce-guardar" data-ce-cl-guardar${cl.destino === null || cl.destino === undefined || cl.enviando || (cl.destino === 'nuevo' && igualDelNuevo(lin, cl, it)) ? ' disabled' : ''}>${cl.enviando ? 'Clasificando…' : 'Clasificar'}</button>
        <button type="button" class="ce-boton" data-ce-cl-cancelar>Cancelar</button></div>
    </section>`;
  };
  const cuerpo = grupos.map((s) => `<section class="ce-seccion" data-ce-grupo><h2>${esc(s.seccion)}<span>${s.items.length} sin línea · sección de la plantilla</span></h2>
    <div class="ce-linea"><div class="ce-filas">${s.items.map((it) => {
      const abierto = !!(cl && cl.itemId === it.itemId);
      return `<div class="ce-item" data-ce-por-clasificar="${esc(it.itemId)}">
        <div class="ce-item-nombre"><b>${esc(it.descripcion || it.ref)}</b><small>${unidadBonita(it.unidad)}${it.precioRef !== null ? ` · referencia ${plata(it.precioRef)}` : ''}</small></div>
        <div class="ce-item-precio"><span class="ce-estado">por clasificar</span></div>
        <button type="button" class="ce-lapiz" data-ce-clasificar="${esc(it.itemId)}" aria-expanded="${abierto}" aria-label="Clasificar ${esc(String(it.descripcion || it.ref).slice(0, 60))}" title="Clasificar">&#9998;</button>
      </div>${abierto ? `<div class="ce-editor-host">${panel(s, it)}</div>` : ''}`;
    }).join('')}</div></div></section>`).join('');
  return `<p class="ce-ayuda">Ítems de la plantilla que todavía no caen en ninguna línea. Con el lápiz eliges dónde van y si son uno que ya tienes o uno nuevo.</p>`
    + (cuerpo || `<p class="ce-vacio" data-ce-vacio>${q ? 'Nada coincide con esa búsqueda.' : 'No queda nada por clasificar.'}</p>`);
}


/**
 * MAD-ITEM-NUEVO-T1: donde va el item nuevo (seccion y linea del cliente) y, debajo, el editor en modo nuevo. La unidad es
 * la de la linea (la pone la base); crear una linea nueva no lo trae la API.
 */
function nuevoEnHtml(lectura, en) {
  const caps = (lectura && lectura.capitulos) || [];
  const cap = caps[en.ck] || caps[0];
  if (!cap) return '';
  return `<section class="ce-nuevo-en" data-ce-nuevo-en aria-label="Ítem nuevo">
    <div class="ce-clasif-donde">
      <label>Sección<select class="ce-saltar" data-ce-nuevo-sec>${caps.map((c, k) => `<option value="${k}"${k === en.ck ? ' selected' : ''}>${esc(c.nombre)}</option>`).join('')}</select></label>
      <label>Línea<select class="ce-saltar" data-ce-nuevo-lin>${cap.lineas.map((l, k) => `<option value="${k}"${k === en.lk ? ' selected' : ''}>${esc(l.linea)}</option>`).join('')}</select></label>
    </div>
    <div class="ce-editor-host" data-ce-editor-host></div>
  </section>`;
}

/** El borrador con que abre el editor de un estandar: sus valores copiados (la variante no comparte arreglos). */
export const borradorDe = (est) => ({ id: est.id, tipo: est.tipo, nombreManual: est.nombreManual || null, caracteristicas: JSON.parse(JSON.stringify(est.caracteristicas || {})), precio: est.precio, vigenteDesde: est.vigenteDesde, revision: est.revision,
  // MAD-NOMBRE-PARAMETROS-DESCRIPCION-T1: la descripcion escrita viaja en el borrador para que el PUT no la borre.
  descripcionManual: est.descripcionManual || null, aceptaDescripcion: !!est.aceptaDescripcion });

/**
 * MAD-LAPIZ-ITEM-T1 (maqueta 1793770085-ef18): el editor de un item estandar montado en $cont, el mismo en Tus items y
 * precios y en la fila del asistente. linea = la de la lectura (n, linea, plantilla, estandar); estandar = el que se
 * edita; borrador = el que venia escrito (si el que lo monta se repinto). alCambiar(borrador) en cada cambio,
 * alCerrar() con Cancelar, alGuardar(lectura, respuesta) despues de guardar y releer el item estandar.
 * EDITOR-ITEM-DISENO-T1: distingue = lo que separa las opciones de la linea (sin el, se calcula con etiquetasCortas);
 * referencia = el precio de la plantilla que se muestra junto a la vigencia.
 */
export function montarEditorEstandar($cont, { linea, estandar, borrador = null, distingue = null, referencia = null, alCambiar = () => {}, alCerrar = () => {}, alGuardar = () => {}, alEliminar = null }) {
  if (!$cont || !linea || !estandar) return;
  let b = borrador || borradorDe(estandar);
  // Los grupos se fijan con lo que el item tenia al abrir: marcar algo en "Mas caracteristicas" no lo hace saltar arriba.
  const extra = {
    alAbrir: JSON.parse(JSON.stringify(b.caracteristicas || {})),
    distingue: distingue || etiquetasCortas((linea.estandar || []).map((e) => ({ etiqueta: e.nombre, estandar: e })), linea.plantilla).distingue,
    referencia: referencia ?? estandar.precioRefMin ?? null,
    // MAD-ELIMINAR-ITEM-T1: Eliminar sale si quien monta el editor sabe que hacer despues (alEliminar).
    puedeEliminar: typeof alEliminar === 'function',
    borrar: null,
    // MAD-NOMBRE-PARAMETROS-DESCRIPCION-T1: la parte 3 (descripcion para el cliente) sale del estandar que se edita.
    estandar
  };
  const poner = (nuevo) => { b = nuevo; alCambiar(b); };
  // MAD-EDICION-COHERENTE-T1: 'Datos para ordenar y buscar' recuerda si quedo abierto y que fila se esta cambiando.
  extra.datosAbierto = null;
  extra.cambiando = null;
  const pintar = () => {
    $cont.innerHTML = editorHtml(linea, b, estandar.unidad, extra);
    const $d = $cont.querySelector('[data-ce-datos]');
    if ($d) $d.addEventListener('toggle', () => { extra.datosAbierto = $d.open; });
  };
  // Al escribir solo cambian el nombre y el boton: el campo no pierde el foco. El nombre escrito a mano no se pisa.
  const refrescar = () => {
    const armado = armadoEnLaLinea(linea, b);
    const $n = $cont.querySelector('[data-ce-nombre]');
    if ($n && !b.nombreManual && document.activeElement !== $n) $n.value = armado;
    if ($n) $n.classList.toggle('a-mano', !!b.nombreManual);
    const $nota = $cont.querySelector('[data-ce-nombre-nota]');
    if ($nota) $nota.innerHTML = notaDelNombre(armado, !!b.nombreManual);
    const $g = $cont.querySelector('[data-ce-guardar]');
    if ($g) $g.disabled = fallasDe(linea.plantilla, b.caracteristicas).length > 0;
    // El aviso de nombre repetido se recalcula al escribir, sin repintar.
    const $r = $cont.querySelector('[data-ce-repetido]');
    if ($r) {
      const rep = nombreRepetido(linea.estandar, b.id, nombreQueQueda(linea, b));
      $r.hidden = !rep;
      $r.innerHTML = rep ? avisoRepetido(linea) : '';
    }
  };
  pintar();
  $cont.addEventListener('input', (e) => {
    const t = e.target;
    if (t.matches('[data-ce-nombre]')) { poner(conNombre(b, t.value, armadoEnLaLinea(linea, b))); refrescar(); return; }
    // MAD-NOMBRE-PARAMETROS-DESCRIPCION-T1: escribir la descripcion no repinta (el foco se queda en el campo).
    if (t.matches('[data-ce-desc-manual]')) {
      poner(conDescripcion(b, t.value, descripcionParaElCliente({ ...estandar, descripcionManual: null })));
      const $s = $cont.querySelector('[data-ce-sale="descripcion"]');
      if ($s) $s.innerHTML = saleDeLaDescripcion({ ...estandar, descripcionManual: b.descripcionManual });
      return;
    }
    if (t.matches('input[type="text"][data-ce-car]')) {
      poner(conCaracteristica(b, t.dataset.ceCar, [t.value])); refrescar();
      // El chip con el mismo valor se marca solo: escribir 12 o tocar 12 es lo mismo.
      $cont.querySelectorAll(`[data-ce-valor="${CSS.escape(t.dataset.ceCar)}"]`).forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.v === t.value.trim())));
      return;
    }
    if (t.matches('[data-ce-precio]')) {
      const v = String(t.value).trim();
      poner(conPrecio(b, v ? parsearNumeroColombiano(v) : null, estandar, hoy()));
      const $v = $cont.querySelector('[data-ce-vigencia]');
      if ($v) $v.textContent = vigenciaTexto(b, extra.referencia);
    }
  });
  // Al salir de un campo de numero se repinta: aparecen las fallas que la base frenaria.
  $cont.addEventListener('change', (e) => { if (e.target.matches('input[type="text"][data-ce-car]')) pintar(); });
  $cont.addEventListener('click', async (e) => {
    const btn = e.target.closest('button');
    if (!btn || !$cont.contains(btn)) return;
    if (btn.dataset.ceTipo !== undefined) { poner({ ...b, tipo: btn.dataset.ceTipo }); pintar(); $cont.querySelector(`[data-ce-tipo="${CSS.escape(btn.dataset.ceTipo)}"]`)?.focus(); return; }
    if (btn.dataset.ceValor !== undefined) {
      const { ceValor: nombre, v } = btn.dataset;
      poner(alternarValor(b, nombre, v, btn.hasAttribute('data-varios'))); pintar();
      $cont.querySelector(`[data-ce-valor="${CSS.escape(nombre)}"][data-v="${CSS.escape(v)}"]`)?.focus();
      return;
    }
    if (btn.dataset.ceCambiar !== undefined) {
      const clave = btn.dataset.ceCambiar;
      extra.cambiando = extra.cambiando === clave ? null : clave;
      extra.datosAbierto = true;
      pintar();
      // Abierta: el foco va a la primera opcion de esa fila; cerrada ('Listo'): vuelve a su boton Cambiar.
      const $fila = $cont.querySelector(`[data-ce-cambiar="${CSS.escape(clave)}"]`);
      (extra.cambiando ? $fila?.parentElement?.querySelector('.ce-op, .ce-num') : $fila)?.focus();
      return;
    }
    if (btn.hasAttribute('data-ce-cancelar')) { alCerrar(); return; }
    if (btn.hasAttribute('data-ce-volver')) { poner({ ...b, nombreManual: null }); pintar(); $cont.querySelector('[data-ce-nombre]')?.focus(); return; }
    if (btn.dataset.ceDescUsar !== undefined) { poner({ ...b, descripcionManual: descripcionesViejas(estandar)[Number(btn.dataset.ceDescUsar)] || null }); pintar(); $cont.querySelector('[data-ce-desc-manual]')?.focus(); return; }
    if (btn.hasAttribute('data-ce-desc-volver')) { poner({ ...b, descripcionManual: null }); pintar(); $cont.querySelector('[data-ce-desc-manual]')?.focus(); return; }
    if (btn.hasAttribute('data-ce-duplicar')) { poner(varianteDe(estandar)); pintar(); return; }
    if (btn.hasAttribute('data-ce-eliminar')) {
      extra.borrar = { contando: true }; pintar();
      const u = await PresupuestosApiClient.usoItemEstandar(estandar.id);
      const n = u.ok ? usoDe(u) : null;
      if (n === null) { extra.borrar = null; pintar(); const $r = $cont.querySelector('[data-ce-resultado]'); if ($r) $r.textContent = u.ok ? 'No pudimos contar en cuántos presupuestos está: intenta de nuevo.' : fraseDelGuardado(u); $cont.querySelector('[data-ce-eliminar]')?.focus(); return; }
      extra.borrar = { pregunta: preguntaDeEliminar(nombreQueQueda(linea, b), n) }; pintar();
      $cont.querySelector('[data-ce-eliminar-no]')?.focus(); return;
    }
    if (btn.hasAttribute('data-ce-eliminar-no')) { extra.borrar = null; pintar(); $cont.querySelector('[data-ce-eliminar]')?.focus(); return; }
    if (btn.hasAttribute('data-ce-eliminar-si') && extra.borrar?.pregunta) {
      extra.borrar = { ...extra.borrar, enviando: true, error: '' }; pintar();
      const r = await PresupuestosApiClient.borrarItemEstandar(estandar.id, estandar.revision);
      if (!r.ok) {
        extra.borrar = { ...extra.borrar, enviando: false, error: r.error?.code === 'ITEM_ESTANDAR_REVISION' || r.code === 409 ? 'Alguien cambió este ítem mientras lo veías: ciérralo y ábrelo otra vez.' : fraseDelGuardado(r) };
        pintar(); $cont.querySelector('[data-ce-eliminar-no]')?.focus(); return;
      }
      const res = await PresupuestosApiClient.itemEstandar();
      alEliminar((res.ok && leerItemEstandar(res)) || null, r, nombreQueQueda(linea, b));
      return;
    }
    if (!btn.hasAttribute('data-ce-guardar')) return;
    const $r = $cont.querySelector('[data-ce-resultado]');
    // MAD-ITEM-NUEVO-T1: uno desde cero va por la ruta que tambien crea su item de la plantilla (sale como tarjeta).
    const v = b.nuevo ? cuerpoDeNuevo(linea, b) : cuerpoDeEstandar(linea, b);
    if (!v.ok) { $r.textContent = v.fallas.map(fraseDeFalla).join(' '); return; }
    btn.disabled = true;
    const r = b.id ? await PresupuestosApiClient.guardarItemEstandar(b.id, v.cuerpo)
      : b.nuevo ? await PresupuestosApiClient.crearItemNuevo(v.cuerpo) : await PresupuestosApiClient.crearItemEstandar(v.cuerpo);
    btn.disabled = false;
    if (!r.ok) { $r.textContent = r.error?.code === 'FORBIDDEN' || r.error?.code === 'NEGOCIO_AJENO' ? motivoDe(r) : fraseDelGuardado(r); return; }
    // Guardado: se relee para mostrar el nombre que armo la base.
    const res = await PresupuestosApiClient.itemEstandar();
    alGuardar((res.ok && leerItemEstandar(res)) || null, r, b);
  });
}

/**
 * Monta el catalogo en $host: lee, pinta y conecta buscar, filtros y Editar; el editor es montarEditorEstandar.
 * MAD-CARGA-ITEMS-T1 (#43872): mientras lee, el esqueleto de la lista nueva (no un texto suelto que deja ver solo el
 * catalogo anterior); si la lectura falla, el motivo y Reintentar. alListo() corre cuando la lista quedo pintada (tambien
 * tras un Reintentar). Devuelve true si pinto la lista.
 */
export async function montarCatalogoEstandar($host, { alListo = () => {}, alCrear = () => {} } = {}) {
  if (!$host) return false;
  $host.innerHTML = '<div class="presu-skel" aria-busy="true" aria-label="Cargando tus ítems" data-ce-cargando><div></div><div></div><div></div><div></div></div>';
  const res = await PresupuestosApiClient.itemEstandar();
  let lectura = res.ok ? leerItemEstandar(res) : null;
  if (!lectura) {
    const vacio = res.ok;
    $host.innerHTML = `<div class="ce-error" data-ce-error role="status"><p>${esc(vacio ? 'Este negocio todavía no tiene ítem estándar cargado.' : motivoDe(res))}</p>
      ${vacio ? '' : '<button type="button" class="ce-boton" data-ce-reintentar>Reintentar</button>'}</div>`;
    $host.querySelector('[data-ce-reintentar]')?.addEventListener('click', () => { montarCatalogoEstandar($host, { alListo, alCrear }); }, { once: true });
    return false;
  }
  // borrador = { n, desde, ...lo escrito }: sobrevive a que el catalogo se repinte (buscar, abrir una linea).
  // MAD-DASHBOARD-ESTILO-T1: el inicio puede pedir abrir con un filtro (precios por confirmar o por clasificar).
  const pedido = ['por_confirmar', 'por_clasificar'].includes(window._nxCatalogoFiltro) ? window._nxCatalogoFiltro : 'todos';
  window._nxCatalogoFiltro = null;
  const estado = { filtro: pedido, buscar: '', borrador: null, clasif: null, aviso: '' };
  const lineaDe = (n) => lectura.capitulos.flatMap((c) => c.lineas).find((l) => l.n === n);
  const pintar = () => {
    $host.innerHTML = catalogoHtml(lectura, estado);
    const $e = $host.querySelector('[data-ce-editor-host]');
    if (!$e || !estado.borrador) return;
    const { n, desde, ...escrito } = estado.borrador;
    const l = lineaDe(n);
    montarEditorEstandar($e, {
      linea: l, estandar: desde ? l?.estandar.find((x) => x.id === desde) : estandarVacio(l), borrador: escrito,
      alCambiar: (b) => { estado.borrador = { ...b, n, desde }; },
      alCerrar: () => {
        const eraNuevo = !desde; estado.borrador = null; estado.nuevoEn = null; pintar();
        $host.querySelector(eraNuevo ? '[data-ce-nuevo]' : `[data-ce-editar="${CSS.escape(desde)}"]`)?.focus();
      },
      alGuardar: (nueva, r, bo) => {
        lectura = nueva || lectura;
        if (bo && bo.nuevo) {
          alCrear();
          // MAD-ITEM-NUEVO-T1: el creado aparece en su linea; el aviso dice donde quedo.
          const cap = lectura.capitulos.find((c) => c.lineas.some((x) => x.n === n));
          estado.aviso = `Creado: ${nombreQueQueda(l, bo)}, en ${cap ? cap.nombre + ' › ' : ''}${l ? l.linea : ''}. Ya sale en el armador.`;
          estado.borrador = null; estado.nuevoEn = null; pintar();
          $host.querySelector('[data-ce-aviso]')?.setAttribute('tabindex', '-1'); $host.querySelector('[data-ce-aviso]')?.focus();
          return;
        }
        estado.borrador = null; pintar();
        $host.querySelector(`[data-ce-linea="${n}"]`)?.insertAdjacentHTML('beforeend', `<p class="ce-resultado" role="status" data-ce-guardado>${esc(fraseDelGuardado(r, bo))}</p>`);
      },
      alEliminar: (nueva, r, nombre) => {
        lectura = nueva || lectura;
        estado.borrador = null; pintar();
        $host.querySelector('[data-ce-barra]')?.insertAdjacentHTML('afterend', `<p class="ce-resultado ce-eliminado" role="status" tabindex="-1" data-ce-eliminado>${esc(fraseDelEliminado(nombre, r))}</p>`);
        $host.querySelector('[data-ce-eliminado]')?.focus();
      }
    });
  };
  pintar();
  // La barra de buscar se pega debajo de la barra del panel (sticky, 46 px en escritorio, mas alta en el celular).
  const $nav = document.getElementById('nx-nav');
  const altoNav = () => $host.style.setProperty('--ce-barra-top', ($nav ? $nav.offsetHeight : 0) + 'px');
  altoNav();
  if ($nav && typeof ResizeObserver !== 'undefined') new ResizeObserver(altoNav).observe($nav);

  // MAD-ITEM-NUEVO-T1: el item nuevo en la seccion ck y la linea lk; lo escrito (nombre, precio) se conserva al cambiar de linea.
  const ponerNuevoEn = (ck, lk) => {
    const l = lectura.capitulos[ck]?.lineas[lk];
    if (!l) return;
    const antes = estado.borrador && !estado.borrador.desde ? estado.borrador : null;
    estado.nuevoEn = { ck, lk };
    estado.borrador = { ...nuevoEstandar(), nombreManual: antes ? antes.nombreManual : null, precio: antes ? antes.precio : null, vigenteDesde: antes ? antes.vigenteDesde : null, n: l.n, desde: null };
  };
  $host.addEventListener('change', (e) => {
    const t = e.target;
    if (estado.nuevoEn && t.matches('[data-ce-nuevo-sec]')) { ponerNuevoEn(Number(t.value), 0); pintar(); $host.querySelector('[data-ce-nuevo-sec]')?.focus(); return; }
    if (estado.nuevoEn && t.matches('[data-ce-nuevo-lin]')) { ponerNuevoEn(estado.nuevoEn.ck, Number(t.value)); pintar(); $host.querySelector('[data-ce-nuevo-lin]')?.focus(); return; }
    // MAD-CLASIFICAR-ITEMS-T1: cambiar la seccion vuelve a la primera linea; cambiar la linea borra el destino elegido.
    if (estado.clasif && t.matches('[data-ce-cl-sec]')) { estado.clasif = { ...estado.clasif, ck: Number(t.value), lk: 0, destino: null, error: '' }; pintar(); $host.querySelector('[data-ce-cl-sec]')?.focus(); return; }
    if (estado.clasif && t.matches('[data-ce-cl-lin]')) { estado.clasif = { ...estado.clasif, lk: Number(t.value), destino: null, error: '' }; pintar(); $host.querySelector('[data-ce-cl-lin]')?.focus(); return; }
    if (!t.matches('[data-ce-saltar]') || !t.value) return;
    $host.querySelector(`#ce-s-${CSS.escape(t.value)}`)?.scrollIntoView({ block: 'start' });
    t.value = '';
  });
  $host.addEventListener('input', (e) => {
    const t = e.target;
    if (estado.clasif && t.matches('[data-ce-cl-nombre]')) {
      const cl = estado.clasif; cl.nombre = t.value;
      const encontrado = itemPorClasificar(lectura, cl.itemId);
      const lin = lectura.capitulos[cl.ck]?.lineas[cl.lk];
      const igual = lin && encontrado ? igualDelNuevo(lin, cl, encontrado.item) : null;
      const $a = $host.querySelector('[data-ce-cl-igual]'); if ($a) { $a.hidden = !igual; $a.textContent = avisoDelIgual(lin, igual); }
      const $g = $host.querySelector('[data-ce-cl-guardar]'); if ($g) $g.disabled = !!igual || !!cl.enviando;
      return;
    }
    if (!t.matches('[data-ce-buscar]')) return;
    estado.buscar = t.value; const pos = t.selectionStart; pintar();
    const $b = $host.querySelector('[data-ce-buscar]'); $b.focus(); $b.setSelectionRange(pos, pos);
  });
  const clasificarAhora = async () => {
    const cl = estado.clasif;
    const encontrado = itemPorClasificar(lectura, cl.itemId);
    const cap = lectura.capitulos[cl.ck];
    const lin = cap && cap.lineas[cl.lk];
    const plan = planDeClasificar({ item: encontrado && encontrado.item, linea: lin, destino: cl.destino, nombre: cl.destino === 'nuevo' ? nombreDelNuevo(cl, encontrado ? encontrado.item : {}) : '' });
    if (!plan.ok) { cl.error = fraseDelPlan(plan, plan.igual && (destinosDeLinea(lin).find((d) => d.id === plan.igual.id) || {}).corto) || plan.fallas.map(fraseDeFalla).join(' '); pintar(); return; }
    cl.enviando = true; cl.error = ''; pintar();
    // Uno nuevo: crear y clasificar en una sola llamada (798); si falla no queda nada. Uno que ya hay: el 797.
    const r = plan.nuevo ? await PresupuestosApiClient.nuevoDesdeItem(plan.itemId, plan.nuevo) : await PresupuestosApiClient.clasificarItemEstandar(plan.estandarId, plan.itemId);
    if (!r.ok) {
      cl.enviando = false;
      cl.error = r.error?.code === 'ITEM_ESTANDAR_NO_EXISTE' ? 'Ese ítem o esa línea ya no está: vuelve a abrir Tus ítems.'
        : r.error?.code === 'ITEM_ESTANDAR_REPETIDO' ? 'Ya hay uno con ese nombre en esta línea: escribe otro nombre o súmalo a ese.' : fraseDelGuardado(r);
      if (plan.nuevo) cl.error += ' No quedó nada creado.';
      pintar(); return;
    }
    const estandarId = plan.nuevo ? idDelEstandar(r) : plan.estandarId;
    const destino = destinosDeLinea(lin).find((d) => d.id === estandarId);
    estado.aviso = fraseDelClasificado({ item: encontrado.item, capitulo: cap.nombre, linea: lin.linea, destinoCorto: destino && destino.corto, nuevo: !!plan.nuevo });
    const res2 = await PresupuestosApiClient.itemEstandar();
    lectura = (res2.ok && leerItemEstandar(res2)) || lectura;
    estado.clasif = null;
    // Uno nuevo sigue en el editor para ponerle sus caracteristicas (como la maqueta); uno que ya habia se queda en la lista.
    const nuevo = plan.nuevo && estandarId ? lineaDe(lin.n)?.estandar.find((x) => x.id === estandarId) : null;
    if (nuevo) { estado.filtro = 'todos'; estado.buscar = ''; estado.borrador = { ...borradorDe(nuevo), n: lin.n, desde: nuevo.id }; }
    pintar();
    if (nuevo) { $host.querySelector('[data-ce-editor]')?.scrollIntoView({ block: 'nearest' }); $host.querySelector('[data-ce-editor] [data-ce-nombre]')?.focus({ preventScroll: true }); }
    else $host.querySelector('[data-ce-aviso]')?.focus?.();
  };
  $host.addEventListener('click', (e) => {
    const b = e.target.closest('button');
    if (!b) return;
    if (b.dataset.ceFiltro) { estado.filtro = b.dataset.ceFiltro; estado.borrador = null; estado.clasif = null; estado.nuevoEn = null; estado.aviso = ''; pintar(); return; }
    if (b.hasAttribute('data-ce-nuevo')) {
      estado.aviso = '';
      if (estado.nuevoEn) { estado.nuevoEn = null; estado.borrador = null; pintar(); $host.querySelector('[data-ce-nuevo]')?.focus(); return; }
      ponerNuevoEn(0, 0); pintar(); $host.querySelector('[data-ce-nuevo-sec]')?.focus(); return;
    }
    if (b.dataset.ceClasificar) {
      const id = b.dataset.ceClasificar; estado.aviso = '';
      if (estado.clasif && estado.clasif.itemId === id) { estado.clasif = null; pintar(); $host.querySelector(`[data-ce-clasificar="${CSS.escape(id)}"]`)?.focus(); return; }
      const encontrado = itemPorClasificar(lectura, id);
      estado.clasif = { itemId: id, ck: capituloSugerido(lectura, encontrado && encontrado.seccion), lk: 0, destino: null, nombre: null, error: '' };
      pintar(); $host.querySelector('[data-ce-cl-sec]')?.focus(); return;
    }
    if (b.dataset.ceClDestino !== undefined && estado.clasif) {
      estado.clasif = { ...estado.clasif, destino: b.dataset.ceClDestino, error: '' }; pintar();
      $host.querySelector(estado.clasif.destino === 'nuevo' ? '[data-ce-cl-nombre]' : `[data-ce-cl-destino="${CSS.escape(b.dataset.ceClDestino)}"]`)?.focus(); return;
    }
    if (b.hasAttribute('data-ce-cl-cancelar') && estado.clasif) { const id = estado.clasif.itemId; estado.clasif = null; pintar(); $host.querySelector(`[data-ce-clasificar="${CSS.escape(id)}"]`)?.focus(); return; }
    if (b.hasAttribute('data-ce-cl-guardar') && estado.clasif && !b.disabled) { clasificarAhora(); return; }
    if (b.dataset.ceEditar) {
      const n = Number(b.closest('[data-ce-linea]').dataset.ceLinea);
      const est = lineaDe(n)?.estandar.find((x) => x.id === b.dataset.ceEditar);
      if (!est) return;
      // El mismo lapiz cierra el editor; otro lo pasa a ese item.
      if (estado.borrador && estado.borrador.desde === est.id) { estado.borrador = null; pintar(); $host.querySelector(`[data-ce-editar="${CSS.escape(est.id)}"]`)?.focus(); return; }
      estado.borrador = { ...borradorDe(est), n, desde: est.id }; estado.nuevoEn = null;
      pintar();
      $host.querySelector('[data-ce-editor]')?.scrollIntoView({ block: 'nearest' });
      $host.querySelector('[data-ce-editor] [data-ce-nombre]')?.focus({ preventScroll: true });
    }
  });
  alListo();
  return true;
}
